export const API_KEY = 'OBBnXJXLBfBgonHW7GKsAQ2u6dQFOFxV';
export const API_URL = 'https://api.giphy.com/v1';